import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import AdminModules from './Modules/Admin/Main';
import AdminAuth from './Modules/Admin/AdminAuth';

import ThemeModule from './Modules/Themes/Main';
import MethodModule from './Modules/Methods/Main';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        AdminModules,
        AdminAuth,

        ThemeModule,
        MethodModule,
    },
    plugins: [
        createPersistedState()
    ]
})
